/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 *
 * Error
 *
 */

import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { ToastContainer, toast } from '@cashfree-intl/coherent';

import { useInjectReducer } from 'utils/injectReducer';
import { logout } from 'utils/common';
import {
  hideToast,
  resetErrorTitle as resetErrorTitleAction,
  resetTwoFactorAuthentication as resetTwoFactorAuthenticationAction,
} from './actions';
import makeSelectError from './selectors';
import reducer from './reducer';

import FormController from '../FormController';

import CustomIcon from '../../components/CustomIcons';

export const Toast = props => {
  useInjectReducer({ key: 'toastReducer', reducer });
  const {
    toastReducer: { isOpen, data, autoCloseTimer, errorTitle, errorData },
    resetErrorTitle,
    resetTwoFactorAuthentication,
  } = props;

  useEffect(() => {
    if (isOpen) {
      const { type = '', message = '' } = data;

      const toastMessage =
        message || 'Something went wrong. Please retry after some time.';

      if (type === 'SUCCESS') toast.success(toastMessage);
      else if (type === 'WARN') toast.warn(toastMessage);
      else toast.error(toastMessage);

      if (message && message.toUpperCase() === 'UNAUTHORIZED') logout();

      setTimeout(() => {
        props.hideToast();
      }, autoCloseTimer);
    }
  }, [isOpen]);

  // eslint-disable-next-line react/prop-types
  const CloseButton = ({ closeToast }) => {
    const handleCloseToast = () => {
      closeToast();
      props.hideToast();
    };

    return (
      <div className="close-toast" onClick={handleCloseToast}>
        <CustomIcon componentName="CLOSE" fill="#FFF" />
      </div>
    );
  };

  return (
    <>
      <ToastContainer
        className={`toast-class ${data?.className}`}
        bodyClassName="toast-body"
        position="bottom-center"
        hideProgressBar
        autoClose={autoCloseTimer}
        closeButton={<CloseButton />}
        newestOnTop={false}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover
        stacked
      />
      {!!errorTitle && (
        <FormController
          componentName={errorTitle}
          open={!!errorTitle}
          errData={errorData}
          {...(errorTitle === 'VERIFY_G2FA' ? { type: '2FA' } : {})}
          message={data ? data.message : ''}
          resetErrorTitle={resetErrorTitle}
          resetTwoFactorAuthentication={resetTwoFactorAuthentication}
        />
      )}
    </>
  );
};

Toast.propTypes = {
  toastReducer: PropTypes.object,
  hideToast: PropTypes.func,
  resetErrorTitle: PropTypes.func,
  resetTwoFactorAuthentication: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  toastReducer: makeSelectError(),
});

function mapDispatchToProps(dispatch) {
  return {
    hideToast: () => dispatch(hideToast()),
    resetErrorTitle: () => dispatch(resetErrorTitleAction()),
    resetTwoFactorAuthentication: data =>
      dispatch(resetTwoFactorAuthenticationAction(data)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  memo,
)(Toast);
